import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../Assets/Logo.svg";
import styles from "./Header.module.css";

const Header = ({ clickable = true }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    if (clickable) {
      navigate("/");
    }
  };

  return (
    <header className={styles.header}>
      <img
        src={Logo}
        alt="App Logo"
        className={styles.logoImg}
        style={{ cursor: clickable ? "pointer" : "default" }}
        onClick={handleLogoClick}
      />
    </header>
  );
};

export default Header;